import { Box, Typography } from "@mui/material";

export const MissingInformation = () => {
  return (
    <Box
      fontStyle="italic"
      display="inline"
      fontSize={"90%"}
      sx={{ opacity: "0.33" }}
    >
      N/A
    </Box>
  );
};

const TypographyWithMiss = ({ children, isMissing, ...props }) => {
  return (
    <Typography {...props} as="div" noWrap>
      {isMissing ? <MissingInformation /> : children}
    </Typography>
  );
};

export default TypographyWithMiss;
